import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base';
export default (function (props, ctx) {
  var profile = function profile() {
    return Base.profile();
  };

  var comment = '';
  var criteria = Base.initdata.review_criteria;
  var scoreOptions = Base.initdata.review_scoring;
  var nguoi_danh_gia = ctx.$f7route.params.actor;
  var nguoi_danh_gia_name = ctx.$f7route.params.actor_name;
  var id_emp = ctx.$f7route.params.victim;
  var name = ctx.$f7route.params.victim_name;
  var month = ctx.$f7route.params.month;

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.api('Review', 'viewResultDetail', {
              nguoi_danh_gia: nguoi_danh_gia,
              id_emp: id_emp,
              month: month
            });

          case 2:
            rs = _context.sent;
            $('.comment-block').text('');

            if (!(rs.scores.length === 0)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", false);

          case 6:
            $('.comment-block').text("G\xD3P \xDD: ".concat(rs.comment));
            rs.scores.forEach(function (scoreRow) {
              $(".scoring-table td[data-id_tieuchi=\"".concat(scoreRow.id_tieuchi, "\"]")).html("<span class=\"text-color-".concat(scoreRow.color, "\">").concat(scoreRow.name, "</span>"));
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="popup" data-name="cross-review-detail-popup">
  <div class="view">
    <div class="page">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Đánh giá chéo</div>
          <div class="right">
            <a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page-content">    
        <div class="block">${nguoi_danh_gia_name} đánh giá ${name}</div>
        <div class="block comment-block" style="margin-top: 0; margin-bottom: 10px;"></div>
        <div class="data-table scoring-table no-margin">
          <table>
            <tbody>
              ${criteria.map(row=>$h`
                <tr>
                  <td class="label-cell">${row.name}</td>
                  <td class="numeric-cell" data-id_tieuchi="${row.id}" style="white-space: nowrap;text-transform: uppercase; font-size: smaller;">-</td>
                </tr>
              `)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
});